export default {"src":"/_next/static/media/slide2.b6bae922.svg","height":740,"width":757,"blurWidth":0,"blurHeight":0};